"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @class Input
 * @description Basic input which all other input types extend from
 */
var React = require("react");
var InputHelper_1 = require("./InputHelper");
var InternalInput_1 = require("./InternalInput");
var util_1 = require("../../../utils/util");
var InputTypes;
(function (InputTypes) {
    InputTypes["Number"] = "number";
    InputTypes["Password"] = "password";
    InputTypes["Text"] = "text";
})(InputTypes = exports.InputTypes || (exports.InputTypes = {}));
// NOT publicly exported! Only used to make additional <XXXInput> components.
var Input = function (_a) {
    var 
    // Custom attributes
    fieldName = _a.fieldName, tooltip = _a.tooltip, inputRef = _a.inputRef, label = _a.label, labelledBy = _a.labelledBy, 
    // Native attributes
    type = _a.type, placeholder = _a.placeholder, propsValue = _a.value, defaultValue = _a.defaultValue, testId = _a.testId, onChange = _a.onChange, onBlur = _a.onBlur, disabled = _a.disabled, rest = __rest(_a, ["fieldName", "tooltip", "inputRef", "label", "labelledBy", "type", "placeholder", "value", "defaultValue", "testId", "onChange", "onBlur", "disabled"]);
    var tooltipAttributes = tooltip
        ? { title: tooltip, "oui-tooltip": "pos:left" }
        : {};
    return (React.createElement(InputHelper_1.default, { disabled: disabled, value: propsValue, defaultValue: defaultValue, fieldName: fieldName, onBlur: onBlur, onChange: onChange, mapFormValue: InputHelper_1.mapEventTargetValue }, function (helper) {
        var describedBy = [helper.hintId, helper.errorId].join(" ").trim();
        var props = __assign({}, rest, util_1.ariaProps({ label: label, describedBy: describedBy, labelledBy: labelledBy }), { disabled: disabled,
            type: type,
            placeholder: placeholder, from: "input", ref: inputRef, name: helper.fieldName, id: helper.fieldId, className: "oui-input oui-react-input", value: helper.value !== undefined ? helper.value : "", onChange: helper.onChange, onBlur: helper.onBlur, "data-test-id": testId }, tooltipAttributes);
        return React.createElement(InternalInput_1.default, __assign({}, props));
    }));
};
exports.default = Input;
//# sourceMappingURL=Input.js.map